import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Citation, CitationRequest } from './CitationTypes';

export function getPaged(publicationId: Id, params: PagedParams) {
  return axios
    .get<PagedResponse<Citation>>(`/citations/${publicationId}/paged`, {
      params,
    })
    .then(getData);
}

export function get(publicationId: Id, id: Id) {
  return axios.get<Citation>(`/citations/${publicationId}/${id}`).then(getData);
}

export function edit(publicationId: Id, id: Id, request: CitationRequest) {
  return axios.put<Citation>(`/citations/${publicationId}/${id}`, request).then(getData);
}

export function create(publicationId: Id, request: CitationRequest) {
  return axios.post<Citation>(`/citations/${publicationId}`, request).then(getData);
}

export function deleteById(publicationId: Id, id: Id) {
  return axios.delete<unknown>(`/citations/${publicationId}/${id}`).then(getData);
}
